import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { MspCwmCreds } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'mspCwmCreds';

export interface State extends Status {
    data: MspCwmCreds | null;
    connected: boolean;
}

export const initialState: State = {
    data: null,
    connected: false,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,
    on(actions.loadMspCwmCreds, (state) => ({ ...state, loading: true })),
    on(actions.loadMspCwmCredsSuccess, (state, { data, connected }) => ({
        ...state,
        data,
        connected,
        loaded: true,
        loading: false,
    })),
    on(actions.loadMspCwmCredsFailure, (state, { error }) => ({ ...state, error, loading: false })),

    on(actions.createMspCwmCredsSuccess, (state, { data }) => ({
        ...state,
        data,
        connected: true,
        error: null,
        loaded: true,
    })),
    on(actions.putMspCwmCredsSuccess, (state, { data }) => ({
        ...state,
        data,
        connected: true,
        error: null,
        loaded: true,
    })),
    on(actions.deleteMspCwmIntegrationSuccess, () => initialState),
);

export const selectDataAndConnection = (state: State) => ({ data: state.data, connected: state.connected });
